<template>
    <div class="about">
        <div class="page-centered">
            <div class="page-centered-padded">
                <div>WELCOME TO</div>
                <div class="deal-number-logo"><img :src="settings.logoImageNoBackground" /></div>
                <div class="text-big deal-number-label">ENTER THE DEAL NUMBER</div>
                <div class="deal-number-input-container"><input type="tel" class="giveaway-input-box deal-number-input" v-model="dealNumber" placeholder="Deal #" /></div>
                <div class="deal-number-button-container">
                    <button id="button-deal" class="button" :disabled="isBusy || !dealNumber">
                        <span v-if="isBusy" class="loading-span-container">
                            <span class="icon"><img :src="`/Assets/img/spin.svg`" /></span> Loading
                        </span>
                        <span v-else>Get Deal</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import settings from '@/settings'

const isBusy = ref<boolean>(false)
const dealNumber = ref<string | null>(null)

onMounted(() => {
    document.title = settings.siteNameCaps + ' | Deal Number'
    console.log(settings)
})
</script>
